<template>
	<div class="content-card-container">
		<div
				:aria-label="title"
				class="content-card"
				:class="['content-card-' + (clickable ? 'clickable' : 'not-clickable')]"
				:role="clickable ? 'button' : null"
				:tabindex="clickable ? 0 : null"
				v-on:click.prevent="onClick"
				v-on:keyup.space="onClick">
			<div class="title">
				{{ title }}
			</div>
			<div class="media-container">
				<div class="media-frame" />
				<div class="media-content">
					<img v-if="mediaRaw && media" :src="media" />
					<img v-else-if="media" :alt="mediaAlt" :src="mediaUrl" />
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import MediaManager from '@/media-manager'

	export default {
		name: 'content-card',
		props: {
			title: {
				type: String,
				required: true
			},
			media: {
				type: String,
				required: false
			},
			mediaRaw: {
				type: Boolean,
				default: false
			},
			index: {
				type: Number,
				default: 1
			},
			themeColorNumber: {
				type: Number,
				default: 1
			},
			clickable: {
				type: Boolean,
				default: true
			}
		},
		computed: {
			mediaUrl() {
				return MediaManager.getMediaUrl(this.media)
			},
			mediaAlt() {
				return MediaManager.getMediaAlt(this.media)
			}
		},
		methods: {
			onClick() {
				this.$emit('onClick')
			}
		}
	}
</script>
<style lang="less" scoped>
	@import "~@less/variables.less";

	.content-card {
		height: 100%;
		z-index: 100;
		min-width: 200px;
		outline: 0 !important;

		&.content-card-clickable {
			cursor: pointer;

			&:hover {
				.media-container {
					box-shadow: @shadow;
				}
			}
		}

		&.content-card-not-clickable {
			cursor: default !important;
		}

		.media-frame {
			transition: all 0.2s ease-in-out;
		}

		.title {
			text-align: center;
			font-weight: 300;
			margin: 10px;
		}

		.media-frame {
			width: 100%;
			height: 100%;
			position: absolute;
			top: 0;
			left: 0;
			border: 4px solid @grey-light;
		}

		.media-container {
			margin: 0 auto;
			height: 250px;
			width: 250px;
			position: relative;
			//height: 200px;
			//width: 100%;
			text-align: center;
			padding: 20px;
			transition: all 0.2s ease-in-out;

			.media-content {
				background: white;
				width: 100%;
				height: 100%;
			}

			img {
				height: 100%;
				width: auto;
			}
		}
	}
</style>
